import styled from 'styled-components';
import { Add16 } from 'ui/icons';
import { SecondaryButton } from 'ui/button';
import { colors, spacing } from 'ui/theme';

export const RedText = styled.span`
  color: ${colors.negative100};
`;

export const Row = styled.section`
  display: flex;
  align-items: center;
  padding: ${spacing.threeQuarter};
  word-break: break-all;
  &:not(:first-of-type) {
    border-top: ${spacing.single} solid ${colors.grey15};
  }

  & > * {
    margin-right: ${spacing.quarter};
    flex: 18% 1 1;
    &:last-of-type {
      margin-left: auto;
    }
  }
`;

export const Header = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  overflow-wrap: break-word;
  padding: ${spacing.quarter} 0;
`;

export const ConfigureButton = styled(SecondaryButton)`
  float: right;
`;

export const StyledAddIcon = styled(Add16)`
  margin-right: ${spacing.half};
`;
